/////////////////////////////////////////////
// DEFAULT PROPS FOR COMPONENTS
/////////////////////////////////////////////

import { BUTTON_GRADIENT } from './colors';

export const FONT_FAMILY = {
  heading: `'Noto Serif Display', serif;`,
  subHeading: `'Noto Serif Display', serif;`,
  subHeading_lv2: `'Noto Serif Display', serif;`,
  body: `'Lora', serif;`,
};

export const TEXT_PROPS = {
  heading: {
    fontFamily: 'heading',
    fontSize: 'heading',
    fontWeight: 'heading',
    fontStyle: 'var(--fontItalic-heading)',
    letterSpacing: '-2px',
    lineHeight: '1',
    textAlign: 'center',
    color: 'secondaryColorText',
  },
  subHeading: {
    fontFamily: 'subHeading',
    fontSize: 'subHeading',
    fontWeight: 'subHeading',
    fontStyle: 'var(--fontItalic-subHeading)',
    letterSpacing: '-1.8px',
    lineHeight: '1',
    color: 'alternativeColorText',
    textAlign: 'center',
  },
  subHeading_lv2: {
    fontFamily: 'subHeading_lv2',
    fontSize: 'subHeading_lv2',
    fontWeight: 'subHeading_lv2',
    fontStyle: 'var(--fontItalic-subHeading_lv2)',
    lineHeight: '1',
    color: 'secondaryColorText',
    textAlign: 'center',
  },
  body: {
    fontFamily: 'body',
    fontSize: 'body',
    fontWeight: 'body',
    fontStyle: 'var(--fontItalic-body)',
    letterSpacing: '-1px',
    color: 'mainColorText',
    textAlign: 'center',
  },
};

export const BUTTON_PADDING_PROPS = {
  ...TEXT_PROPS.body,
  variant: 'solid',
  padding: '14px 24px',
  borderRadius: 'full',
  background: BUTTON_GRADIENT,
  color: 'bgSecondary',
  size: 'sm',
  boxShadow: 'sm',
  fontStyle: 'normal',
  _active: { opacity: '.8' },
  _hover: { opacity: '.8' },
  _focus: { opacity: '.8' },
};
